import React from 'react';
import { defaultPageConfig, Page } from "/src/domain/shared/Page";

import '../../i18n';

import { User, UserRole } from "/src/domain/shared/User";

import { mountComponentToContainer } from "/src/domain/shared/mountUtils";

import { ChallengeRatingCupData } from '/src/domain/challenges/ChallengeRatingCup';
import ChallengeRatingCupApp from './ChallengeRatingCupApp';

window.mountPage = mountPage;

function mountPage(page: Page, pageData: ChallengeRatingCupData, currentUser?: User) {
    if (page !== Page.CHALLENGE_RATING_CUP) {
        console.error('Unknown page type');
        return;
    }

    mountComponentToContainer(page, pageData, currentUser, defaultPageConfig, ChallengeRatingCupApp)
}

// mountPage(Page.CHALLENGE_RATING_CUP, {
//     cup: {
//         name: 'Кубок ЭФКО',
//         races: [
//             {
//                 id: 1,
//                 name: "Taman",
//                 protocolLink: "https://challenges.s10.run/rating?protocol=%D0%AD%D0%A4%D0%9A%D0%9E%20Challenge.%20%D0%A2%D0%B0%D0%BC%D0%B0%D0%BD%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BC%D0%B8%D0%BB%D1%8F%201852%20m",
//                 isPast: true
//             },
//             {
//                 id: 2,
//                 name: "Biruch",
//                 // protocolLink: "https://challenges.s10.run/rating?protocol=%D0%AD%D1%84%D0%BA%D0%BE%20Challenge%20-%20Biruch%20Run%205%20km",
//                 isPast: true
//             }
//         ],
//         totalRaces: 3,
//         logoUrl: 'http://challenges.s10.run/i/logo_efko_350.png'
//     },
//     records: [
//         {
//             participant: {
//                 id: '123',
//                 firstName: 'Дима',
//                 lastName: 'Неделин',
//                 isPremium: false
//             },
//             time: 1230,
//             absolute: 1300,
//             raceResults: [
//                 {
//                     time: 600,
//                     absolute: 650
//                 },
//                 {
//                     time: 600,
//                     absolute: 650
//                 }
//             ],
//             place: 1
//         },
//         {
//             participant: {
//                 id: '456',
//                 firstName: 'Дима',
//                 lastName: 'Неделин 2',
//                 isPremium: false,
//                 coach: "Coach 1",
//                 city: "Spb"
//             },
//             time: 1230,
//             absolute: 1300,
//             raceResults: [
//                 {
//                     time: 600,
//                     absolute: 650
//                 },
//                 {
//                     time: 600,
//                     absolute: 650
//                 }
//             ],
//             place: 2
//         }
//     ]
// }, {
//     id: '50698840',
//     role: UserRole.STUDENT,
//     isPremium: false,
//     trainingsRequests: []
// });
